
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent7 as ObiWindApparent7Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-7.js';
 
 
 

 
 export const ObiWindApparent7 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-7',
   elementClass: ObiWindApparent7Element,
   events: {
     
   }
  });
 
 